import { Helmet } from 'react-helmet-async';
// sections
import DashboardAnnoucementView from 'src/sections/main-sections/annoucements/view/annoucement-view';

// ----------------------------------------------------------------------

export default function AnnoucementPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Annoucement</title>
      </Helmet>

      <DashboardAnnoucementView />
    </>
  );
}
